module.exports = __webpack_public_path__ + "static/media/image-9.4912c06b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-9.jpg
// module id = 286
// module chunks = 0